module.exports = __webpack_public_path__ + "static/barbarawork8-da40499f214cdd593c9d96b9f931ee3b.jpg";